import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useStoreState } from '~/store';
import ActionList from 'Components/ActionList';
import {
  useProductById,
  useUserProductsTradeActions,
} from '~/hooks/useProducts';

export default ({ order, action }) => {
  const productsTradeActions = useUserProductsTradeActions();
  const solutionDivisions = useStoreState(
    (state: any) => state.auth.solutionDivisions
  );
  const restrictedAccess = solutionDivisions.some(
    (s: any) => s?.restrictedaccess
  );
  const productId = order?.product?.id;
  const product = useProductById(productId);

  const tradeActions = product?.id ? productsTradeActions?.[product.id] : null;
  const buyProductId = tradeActions?.buy;
  const sellProductId = tradeActions?.sell;

  if (!(buyProductId || sellProductId) || restrictedAccess) {
    return null;
  }

  if (action) {
    return (
      <>
        {buyProductId && (
          <ActionList.Item>
            <Link
              to={`/orders/bid?product=${order.product.id}&order=${order.id}`}
            >
              <span>
                <FormattedMessage
                  id="marketrow-neworder-button-copy-bid"
                  defaultMessage="Copy bid"
                />
              </span>
            </Link>
          </ActionList.Item>
        )}
        {sellProductId && (
          <ActionList.Item>
            <Link
              to={`/orders/offer?product=${order.product.id}&order=${order.id}`}
            >
              <span>
                <FormattedMessage
                  id="marketrow-neworder-button-copy-offer"
                  defaultMessage="Copy offer"
                />
              </span>
            </Link>
          </ActionList.Item>
        )}
      </>
    );
  }

  return (
    <div className="bid-message">
      <p className="desc">
        <FormattedMessage
          id="marketrow-neworder-helptext"
          description="helptext for `new order` field in Marketrow"
          defaultMessage="<strong>Create a new order</strong> based on the details of this one."
          values={{ strong: (chunks: any) => <strong>{chunks}</strong> }}
        />
      </p>
      <div className="nowrap">
        {buyProductId && (
          <Link
            to={`/orders/bid?product=${order.product.id}&order=${order.id}`}
            className="pill place-bid"
          >
            <span>
              <FormattedMessage
                id="marketrow-neworder-button-bid"
                description="button for `new order` field bid in Marketrow"
                defaultMessage="New bid"
              />
            </span>
          </Link>
        )}
        {sellProductId && (
          <Link
            to={`/orders/offer?product=${order.product.id}&order=${order.id}`}
            className="pill place-offer"
          >
            <span>
              <FormattedMessage
                id="marketrow-neworder-button-offer"
                description="button for `new order` field offer in Marketrow"
                defaultMessage="New offer"
              />
            </span>
          </Link>
        )}
      </div>
    </div>
  );
};
